
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Womens from './components/pages/Womens';
import Ranaghat from './components/pages/Ranaghat';
import Menswear from './components/pages/Menswear';
import Bethuashop from './components/pages/Bethuashop';
import Contactus from './components/pages/Contactus';
import Saree from './components/pages/Saree';
import Kidsware from './components/pages/Kidsware';
import MenPunjabi from './components/pages/MenPunjabi';
import MenTshirt from './components/pages/MenTshirt';
import MenBlazer from './components/pages/MenBlazer';
import Sareepage from './components/pages/Sareepage';
import Weddingpage from './components/pages/Weddingpage';
import KarimpurShowroom from './components/pages/KarimpurShowroom';


function App() {
  return (
    <Router>

      <div>



        <Routes>

          <Route axact path="/" element={<Home />} />
          <Route axact path="/womens-wear" element={<Womens />} />
          <Route axact path="/mens-wear" element={<Menswear />} />
          <Route axact path="/Ranaghat_showroom" element={<Ranaghat />} />
          <Route axact path="/Bethuadahari_showroom" element={<Bethuashop />} />
          <Route axact path="/Contactus" element={<Contactus />} />
          <Route axact path="/saree" element={<Saree />} />
          <Route axact path="/Kidsware" element={<Kidsware />} />
            <Route axact path="/MenPunjabi" element={<MenPunjabi/>}/>
             <Route axact path="/T_shirt" element={<MenTshirt/>}/>
             <Route axact path="/MenBlazer" element={<MenBlazer/>}/>
              <Route axact path="/saree_trending" element={<Sareepage/>}/>
               <Route axact path="/wedding_page" element={<Weddingpage/>}/>
                          <Route axact path="/KarimpurShowroom" element={<KarimpurShowroom/>}/>
        </Routes>
        <Footer />

      </div>

    </Router>
  );
}

export default App;
